import { makeStyles } from "@material-ui/core";

export const css = makeStyles((theme) => ({
    modal: {
        textAlign: "center",
    },
    container: {
        display: "flex",
        flexDirection: "column",
        padding: "0 30px",
    },
    header: {
        display: "flex",
        alignItems: "center",
        margin: "0 auto",
    },
    title: {
        fontWeight: "bold",
        margin: "20px auto",
    },
    closeButton: {
        zIndex: 1,
        position: "absolute",
        marginLeft: "65%",
        cursor: "pointer",
    },
    produtosTitle: {
        fontWeight: "700",
    },
    produtos: {
        margin: "15px 0 30px 15px",
    },
    buttonsDiv: {
        margin: "15px auto 20px auto",
    },
    button: {
        color: theme.palette.primary.main,
        fontWeight: "500",
        fontSize: "16px",
    }
}));
